var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import { FlowTaskService } from '~/services/domain-service/flow-task.service';
import CaseApprovalCommon from '~/components/approval-manage/own-approval/case-approval-common.vue';
var ApprovalNode = /** @class */ (function (_super) {
    __extends(ApprovalNode, _super);
    function ApprovalNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            commonState: '',
            applyCategory: '',
        };
        _this.rowData = '';
        _this.dataSet = [];
        _this.dialog = {
            leaveApproval: false,
        };
        return _this;
    }
    /**
     * 修改审批类型设置状态
     */
    ApprovalNode.prototype.applyCategory = function (row) {
        var _this = this;
        this.flowTaskService
            .applyCategory({
            commonState: row.commonState === 'DISABLED' ? 'ENABLED' : 'DISABLED',
            id: row.id,
        })
            .subscribe(function (data) {
            _this.refreshData();
        });
    };
    ApprovalNode.prototype.mounted = function () {
        this.refreshData();
    };
    ApprovalNode.prototype.refreshData = function () {
        var _this = this;
        this.flowTaskService
            .queryApplyCategory(this.searchModel, this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    __decorate([
        Dependencies(PageService)
    ], ApprovalNode.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], ApprovalNode.prototype, "sortService", void 0);
    __decorate([
        Dependencies(FlowTaskService)
    ], ApprovalNode.prototype, "flowTaskService", void 0);
    ApprovalNode = __decorate([
        Auth(1702),
        Layout('workspace'),
        Component({
            components: {
                CaseApprovalCommon: CaseApprovalCommon,
            },
        })
    ], ApprovalNode);
    return ApprovalNode;
}(Vue));
export default ApprovalNode;
